<template>
  <div class="animated fadeIn item-list">
    <b-card v-show="showList">
      <div slot="header">Master Item List  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="btn btn-primary mr-1" @click="manageImages">
              <i class="fa fa-file-image-o"></i> Images           
          </b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="7">
              <b-row no-gutters>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><label>Item Name</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.itemname"  placeholder="Item Name"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="5">
                  <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Code/Number &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.itemcode"  placeholder="Item Code"></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row>                      
            <b-input-group >
                <b-input-group-prepend><label>Item Category</label></b-input-group-prepend>
                <b-form-select v-model="tblData.itemcategory" :plain="true" :options="itemCategories" > </b-form-select>
                <b-input-group-append><span class="input-group-text">&nbsp;&nbsp; Head Category</span></b-input-group-append>
                <b-form-select v-model="tblData.headcategory" :plain="true" :options="headCategories" ></b-form-select>
            </b-input-group>
        </b-col>
        <b-col  lg="5">
            <b-input-group >
                <b-input-group-prepend><label>Item Usage Type </label></b-input-group-prepend>
                <b-form-select v-model="tblData.itemUsageType" :plain="true" :options="['FIXED ASSET','REUSABLE','CONSUMABLE','']"></b-form-select>
                <b-input-group-append><label class="pt-2">Group</label></b-input-group-append>
                <b-form-input v-model="tblData.group" placeholder="custom group name" class="ml-1"></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Material/Services</label></b-input-group-prepend>
                <b-form-select v-model="tblData.jasa" :plain="true" :options="jasaMaterial"></b-form-select>
                <b-input-group-append><label class="pt-2">Active</label></b-input-group-append>
                <b-form-select v-model="tblData.isactive" :plain="true" :options="activeStatus"></b-form-select>
                  <b-input-group-append>
                        <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                  </b-input-group-append>
                  <b-input-group-append>
                        <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear </b-button>
                  </b-input-group-append>
            </b-input-group>
          </b-col>
      </b-row>   

          <b-table
            class="mb-0"
            ref="tblVendor"
            responsive striped hover 
            style="font-size:smaller;"
            :items="data"
            :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectItem"
          >
          <template v-slot:cell(action)="data">
            <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
              <template v-slot:button-content>
                <i class="fa fa-play text-primary"></i>
              </template>
              <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;" >Edit</b-dropdown-item>
              <b-dropdown-item @click="rowImages(data.item)" href="#"  style="padding:0 !important;" >Images</b-dropdown-item>
              <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;" > Delete</b-dropdown-item>
            </b-dropdown>
          </template>        
            <template v-slot:cell(jasa)="data">
              <span v-if="(data.item.jasa==1)">Service</span>
              <span v-else>Material</span>
            </template>
            <template v-slot:cell(isexpireable)="data">
              <span v-if="(data.item.isexpireable==1)">Expireable</span>
            </template>
            <template v-slot:cell(lastvendor)="data">
              {{ data.item.lastvendor}}
              <p style="margin-top:0; margin-bottom:0" v-if="(data.item.lastprice)">
                Last Price: {{data.item.lastpriceuang}} {{data.item.lastprice | numFormat}} <span v-if="data.item.lastpriceunit"> / {{data.item.lastpriceunit}}</span>
              </p>
             <p style="margin-top:0; margin-bottom:0" v-if="(data.item.lastpo)">Last Order: {{data.item.lastpo}}</p> 
            </template>
          </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="(showList==false)">
      <div slot="header">Master Item - Images 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
        <b-row >
          <b-col>
            <b-row>
              <b-col md="6">
                <b-input-group >
                  <b-input-group-prepend><label>Item Code</label></b-input-group-prepend>
                    <b-form-input v-model="model.partnumber" disabled ></b-form-input>
                </b-input-group >
              </b-col>
              <b-col md="6">                            
                <b-form-radio-group class="mt-2" v-model="model.jasa" name="radioJasa" disabled>
                  <b-form-radio value="0">Material</b-form-radio>
                  <b-form-radio value="1">Service</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
            <b-input-group >
              <b-input-group-prepend><label>Item Name</label></b-input-group-prepend>
                <b-form-input v-model="model.itemname" disabled ></b-form-input>
            </b-input-group >
            <b-row>
              <b-col class="pr-1" md="6">
                <!-- <b-input-group >
                  <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                  <b-form-input  v-model="model.typeseries" disabled></b-form-input>
                </b-input-group > -->
                  <b-input-group >
                      <b-input-group-prepend><label> Inventory UnitSize</label></b-input-group-prepend>
                      <b-form-input v-model="model.invunitom" disabled></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col class="pl-1" md="6">                            
                  <b-input-group >
                      <b-input-group-prepend><label> Purchase UnitSize</label></b-input-group-prepend>
                      <b-form-input v-model="model.unitsize" disabled></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>                      
          </b-col>
      </b-row>
        <b-card-group>
          <b-card v-for="(item,index) in itemImg" :key="item.imgKey" img-alt="Image" img-top>
            <my-upload field="gambar" :noCircle="true" 
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="showImgTool"
                :width="300"
                :height="300"
                :url="imgUploadUrl"
                langType="en"
                :params="itemImg[index].imgParams"
                :headers="imgHeaders"
                img-format="png"></my-upload>
            <img :src="itemImg[index].imgDataUrl">
            <div slot="footer">
              <b-button variant="btn btn-primary mr-1" @click="toggleShowImg(index)"> <i class="fa fa-file-image-o"></i> Upload</b-button>
              <b-button variant="btn btn-primary mr-1" @click="deleImage(index)"><i class="fa fa-trash"></i>
              </b-button>
              </div>
          </b-card>
        </b-card-group>      
    </b-card>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
  </div>
</template>
<style lang="scss">
  .item-list {
    table {
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
 }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
      .input-group {
          .input-group-prepend {
              label {
                  width: 110px !important;
              }
          }
      }

    }
</style>

<script>
// import fs from "fs";
import item from "../../apis/item";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'babel-polyfill'; // es6 shim
import myUpload from 'vue-image-crop-upload';
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
        {
          key: "action",
          label: "",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: "width:50px",
        },
          {
            key: "partnumber",
            label: "Item Code",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "jasa",
            label: "_",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "typeseries",
            label: "Type/Series",
          },
          {
            key: "unitsize",
            thStyle: "width:80px",
            label: "Order UnitSize",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "invunitom",
            thStyle: "width:80px",
            label: "Inventory Size",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "isexpireable",
            thStyle: "width:100px",
            label: "Expireable",
          },
          {
            key: "lastvendor",
            label: "Latest Vendor/Price"
          },
          {
            key: "itemUsageType",
            label: "Freq. Usage",
            sortable: true
          },
          {
            key: "headcategory",
            thStyle: "width:80px",
            label: "Group",
            sortable: true
          },
          {
            key: "nmcategory",
            thStyle: "width:80px",
            label: "Category",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        headcategory:null
      },
      items:[],
      model:{},
      itemImg:[{imgDataUrl:'', imgKey:'0'},{imgDataUrl:'', imgKey:'1'},{imgDataUrl:'', imgKey:'2'},{imgDataUrl:'', imgKey:'3'}],
      imgParams:{name:'gambar'},
      imgHeaders:{},
      imgDataUrl: '',
      imgUploadUrl: '',
      img3:'',
      imgIndex:0,
      showImgTool:false,
      isLoading:false,
      showDelConfirm: false,
      showFilter:false,
      showList:true,
      showReport:false,
      reportUrl: null,
        activeStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Discontinued' },{ value: '1', text: 'Active/In Use' }],
        jasaMaterial : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Material ' },{ value: '1', text: 'Service' }],
      headCategories:[], itemCategories:[],
      namaRoute:''
    };
  },
  components :{Loading,myUpload},
  created: async function(){
      localStorage.setItem("itemRoute", this.$route.name);
      this.namaRoute = this.$route.name;
        const [a,b] = await Promise.all([item.headgroup(),item.group()]) ;
        this.headCategories = a.reduce((newArr,item) =>{
            newArr.push({ value: item.value, text: item.text});
            return newArr;
        },[{value:'', text:'--- ALL ---'}]);
        this.itemCategories = b.reduce((newArr,item) =>{
            newArr.push({ value: item.value, text: item.text});
            return newArr;
        },[{value:'', text:'--- ALL ---'}]);
  },
  methods: {
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.itemlist) {
            this.tblData[key] = filter.itemlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.itemlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      let list = await item.list(this.tblData);
      this.items=list;
      this.lkuLoading = false;
      return list;  
    },
    selectItem(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    refresh() {
      this.$refs.tblVendor.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.itemcode = '';
        this.tblData.itemname =  '';
        this.tblData.headcategory = '';
        this.tblData.itemcategory =  '';
        this.tblData.itemUsageType =  '';
        this.tblData.group = '';
        this.tblData.jasa = '';
        this.tblData.isactive = '';
        this.refresh();
    },    
    add: function(data) {
          const filter = this.$store.state.filter;
          filter.itemlist=this.tblData;
          this.$store.commit("filter", filter);
          if (this.namaRoute.includes('procurement')) {
              router.push({name :'procurement.itemfrm'});
          } else {
              router.push({name :'logistic.itemfrm'});
          }
    },
    edit: function() {
        if (this.model) {
          const filter = this.$store.state.filter;
          filter.itemlist=this.tblData;
          this.$store.commit("filter", filter);
          if (this.namaRoute.includes('procurement')) {
              router.push({name :'procurement.itemfrm', params: { itemno: this.model.itemno}});
          } else {
              router.push({name :'logistic.itemfrm', params: { itemno: this.model.itemno}});
          }
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    rowEdit(record) {
      this.rowClicked(record);
      this.edit();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    rowImages(record) {
      this.rowClicked(record);
      this.manageImages();
    },
    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await item.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.itemno==this.model.itemno));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    manageImages: async function() {
        if (this.model) {
          this.showList=false;
          const data = await item.token();
          this.imgHeaders= data.headers;
          this.imgUploadUrl= `${data.baseURL}/item/uploadImage`;
          this.imgParams= {itemno:this.model.itemno};
          const imgOnSvr = await item.images(this.model);
          for (let index = 0; index < 4; index++) {
            this.itemImg[index].imgKey=index;
            this.itemImg[index].imgDataUrl=''
            this.itemImg[index].imgParams= {itemno:this.model.itemno,imgKey:index };
            if (index<imgOnSvr.length) {
              this.itemImg[index].imgKey=imgOnSvr[index].imgKey;
              this.itemImg[index].imgDataUrl=imgOnSvr[index].imgBase64;
              this.itemImg[index].imgParams.imgKey=imgOnSvr[index].imgKey;
              // dibawah ini cara lain menampilkan gambar dari server tanpa di konversi ke base64            
              // this.itemImg[index].src=`${data.baseURL}/image/asset/${imgOnSvr[index].imgKey}`;
              // in HTML Template do like this: <img :src="itemImg[index].src">
            }
          }
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleImage: async function(index) {
      try {
        this.isLoading=true;
        await item.imageDel({imgKey: this.itemImg[index].imgKey});
          this.itemImg[index].imgKey='';
          this.itemImg[index].imgDataUrl='';
          this.itemImg[index].imgParams.imgKey='';
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        console.log('error : ', error);
        if (error.sql) {
            toastr.error(error.sql,'ERROR MESSAGE',10000);
        } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
        } else if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }   
      }
    },

    toggleShowImg(index) {
        this.imgIndex=index;
          console.log('this.imgIndex ',this.imgIndex);
          this.showImgTool = !this.showImgTool;
    },
    cropSuccess(imgDataUrl, field){
        console.log('-------- crop success --------', field);
        this.itemImg[this.imgIndex].imgDataUrl = imgDataUrl;
        console.log(imgDataUrl);
        console.log('content ',this[field]);
    },
    cropUploadSuccess(jsonData, field){
        console.log('-------- upload success --------');
        console.log(jsonData);
        console.log('field: ' + field);
    },
    cropUploadFail(status, field){
        console.log('-------- upload fail --------');
        console.log(status);
        console.log('field: ' + field);
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await item.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE',10000);
            }
        }
    },
    closeFrm(){
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
